import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["actionItem"],
  _excluded2 = ["children", "color"],
  _excluded3 = ["children"],
  _excluded4 = ["followers", "children"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from '../../hooks';
import { Avatar, AvatarList } from '../Avatar';
import { PlayShapeButton } from '../Buttons';
import { FormattedDate } from '../FormattedDate';
import { Icon } from '../Icon';
import { MapLocation } from '../Icons';
import { Box, Col, Flex, Grid, Row } from '../Layout';
import { KeyTag, SecondaryText, Title } from '../Typography';
export const Info = Box;
Info.Main = React.memo(function InfoMain(_ref) {
  let {
      actionItem
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(Grid, {
    gridTemplateColumns: actionItem ? 'auto 1fr' : '1fr',
    gridGap: [2, 3],
    alignItems: "center"
  }, actionItem, React.createElement(Flex, _extends({
    flexDirection: "column",
    justifyContent: "center"
  }, props)));
});
Info.Name = Title;
Info.Type = KeyTag;
Info.Date = FormattedDate;
Info.Location = function InfoLocation(_ref2) {
  let {
      children,
      color
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return React.createElement(Flex, _extends({
    alignItems: "center"
  }, props), React.createElement(Icon, {
    pr: 1,
    fontSize: "12px",
    color: color
  }, React.createElement(MapLocation, null)), React.createElement(KeyTag, {
    color: color,
    style: {
      textTransform: 'capitalize',
      fontSize: '14px',
      letterSpacing: '0',
      lineHeight: '16px'
    },
    wrapped: true
  }, children));
};
Info.Location.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string
};
Info.Location.defaultProps = {
  color: 'text.secondary'
};
Info.Avatar = React.memo(function InfoAvatar(props) {
  const isMobileOrTablet = useMediaQuery('mobile', 'tablet');
  return React.createElement(Avatar, _extends({
    size: isMobileOrTablet ? 'large' : 'huge'
  }, props));
});
Info.Music = styled(PlayShapeButton).withConfig({
  displayName: "Music",
  componentId: "sc-5vc23b-0"
})([""]);
Info.Music.defaultProps = {
  width: 70,
  height: 72
};
Info.Tag = styled(KeyTag).withConfig({
  displayName: "Tag",
  componentId: "sc-5vc23b-1"
})([""]);
Info.Tag.defaultProps = {
  as: 'span',
  fontWeight: 900,
  color: 'nightgraph'
};
Info.Tags = React.memo(function InfoTags(_ref3) {
  let {
      children
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  const count = React.Children.count(children);
  const enhancedChildren = React.Children.map(children, (child, pos) => React.createElement(React.Fragment, {
    key: child.props.id || pos
  }, React.createElement(Col, {
    width: "auto",
    px: 1
  }, child), pos !== count - 1 && React.createElement(Info.Tag, {
    color: child === null || child === void 0 ? void 0 : child.props.color
  }, "\u2219")));
  return React.createElement(Row, _extends({
    mx: -1,
    marginY: [2, 3]
  }, props), enhancedChildren);
});
Info.Followers = React.memo(function InfoFollowers(_ref4) {
  let {
      followers,
      children
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return React.createElement(Flex, _extends({
    alignItems: "center"
  }, props), React.createElement(AvatarList, {
    data: followers,
    size: "tiny",
    marginRight: 3
  }), React.createElement(SecondaryText, null, children));
});
Info.Main.propTypes = {
  actionItem: PropTypes.node
};
Info.Main.defaultProps = {
  actionItem: null
};
Info.Followers.propTypes = {
  followers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    profileImageUrl: PropTypes.string
  }))
};
Info.Followers.defaultProps = {
  followers: []
};